import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter as Router } from "react-router-dom";
import App from "App";
import { SoftUIControllerProvider } from "context";
import { SnackbarProvider, closeSnackbar } from "notistack";
import { Button, Icon } from "@mui/material";
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(

  <Router basename={process.env.REACT_APP_BASE_NAME}>
    <SoftUIControllerProvider>
      <SnackbarProvider
        autoHideDuration={5000}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        maxSnack={3}
        action={(snackbarId) => (
          <Button onClick={() => closeSnackbar(snackbarId)}>
            <Icon sx={{ cursor: "pointer", fontWeight: "bold", color: "#ffffff" }} fontSize="small">
              close
            </Icon>
          </Button>
        )} >
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <App />
        </LocalizationProvider>
      </SnackbarProvider>
    </SoftUIControllerProvider>
  </Router>
);
